module.exports = __webpack_public_path__ + "93720fb88ee1ec1040f7fb9b61bcf4c6.svg";